var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.917,
    height: 23.02,
    viewBox: "0 0 24.917 23.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#138de8;}.b{stroke:#fdfdfd;stroke-width:2px;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.604)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.791,18.839a1.578,1.578,0,1,1,1.579,1.577A1.579,1.579,0,0,1,15.791,18.839Zm-11.72,0a1.577,1.577,0,1,1,1.577,1.577A1.578,1.578,0,0,1,4.071,18.839ZM5.822,15.61a2.675,2.675,0,0,1-2.631-2.267l-.02-.171L2.22,1.823.647,1.552A.784.784,0,0,1,0,.754L.011.648A.78.78,0,0,1,.781,0H.809l.106.01L3.081.386a.78.78,0,0,1,.626.59l.019.115L3.971,4.01H18.655A2.156,2.156,0,0,1,20.25,4.7a2.183,2.183,0,0,1,.577,1.639L20.81,6.5l-.988,6.832A2.671,2.671,0,0,1,17.36,15.6l-.171.006ZM4.729,13.042a1.1,1.1,0,0,0,.972,1l.121.007H17.19a1.1,1.1,0,0,0,1.061-.819l.024-.122.989-6.832a.616.616,0,0,0-.517-.7l-.092-.007H4.1Zm7.9-3.621a.781.781,0,0,1-.106-1.555l.106-.008h2.888a.782.782,0,0,1,.106,1.556l-.106.007Z",
    transform: "translate(0 0)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(15.916)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 4.5,
    cy: 4.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 4.5,
    cy: 4.5,
    r: 3.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/buy.ca9109e87bb05c054e4b055bddd989ca.svg";
export { ForwardRef as ReactComponent };